module.exports = __webpack_public_path__ + "img/tu04.c6892f16.jpg";